export default __webpack_public_path__ + "static/media/gwn47.63f9c822.webp";